<template class="d-flex flex-column">
    <dx-tree-list
        id="mped-plan-dx-tree-list"
        class="flex-grow-1"
        height="50px"
        width="100%"
        ref="treeListRef"
        key-expr="kod_spr_smet"
        parent-id-expr="parent_row_id"
        column-resizing-mode="widget"
        filter-mode="fullBranch"
        :header-filter="{ visible: true }"
        :filter-panel="{ visible: true }"
        :filter-row="{ visible: true }"
        :data-source="dataSource"
        :auto-expand-all="true"
        :allow-column-resizing="true"
        :hover-state-enabled="true"
        :show-column-lines="true"
        :show-row-lines="true"
        :show-borders="true"
        :column-min-width="70"
        :column-chooser="{ enabled: true, mode: 'select' }"
        :remote-operations="false"
        item-template="treeListItemTemplate"
        @toolbar-preparing="onToolbarPreparing($event)"
        @editor-preparing="onEditorPreparing($event)"
        @cell-prepared="onCellPrepared($event)"
        @content-ready="onContentReady($event)"
    >
        <dx-load-panel :enabled="true" />
        <dx-scrolling mode="virtual" />
        <dx-sorting mode="single" />
        <dx-selection mode="single" />
        <dx-editing
            :allow-updating="true"
            :allow-adding="false"
            :allow-deleting="false"
            start-edit-action="click"
            mode="batch"
        />
        <dx-column
            dataField="code"
            caption="Код статьи"
            width="200px"
            :allowEditing="false"
            :fixed="true"
        ></dx-column>
        <dx-column
            dataField="name"
            caption="Статья сметы"
            width="400px"
            :minWidth="250"
            :allowEditing="false"
        ></dx-column>
        <dx-column
            dataField="id"
            caption="id"
            width="100px"
            :visible="false"
            :allowEditing="false"
        ></dx-column>
        <dx-column
            dataField="kod_direct"
            caption="kod_direct"
            width="100px"
            :visible="false"
            :allowEditing="false"
        ></dx-column>
        <dx-column
            dataField="kod_spr_smet"
            caption="kod_spr_smet"
            width="100px"
            :visible="false"
            :allowEditing="false"
        ></dx-column>
        <dx-column
            dataField="kod_col"
            caption="kod_col"
            width="100px"
            :visible="false"
            :allowEditing="false"
        ></dx-column>
        <dx-column v-for="(item, index) in columns"
                   :key="index"
                   :caption="item.caption"
                   :data-field="item.dataField"
                   :visible="item.visible"
                   :editor-options="item.editorOptions"
                   :lookup="item.lookup || null"
                   :data-type="item.dataType || 'string'"
                   :calculate-cell-value="item.calculateCellValue"
                   :calculate-display-value="item.calculateDisplayValue"
                   :width="item.width"
                   :sort-index="item.sortIndex"
                   :sort-order="item.sortOrder"
                   :validation-rules="item.validationRules"
                   :allow-editing="item.allowEditing"
                   :format="item.format"
        ></dx-column>
        <dx-column
            dataField=""
            caption=""
            minWidth="0"
            :visible="true"
            :showInColumnChooser="false"
            :allowEditing="false"
        ></dx-column>

        <template #filterFilialTemplate>
            <div class="d-flex">
              <ai-drop-down-tab
                ref="sprDepartmentComboRef"
                :columns="[{ caption: 'Наименование', dataField: 'name' }]"
                :get-data-source="getDsSprDepartmentsCombo"
                drop-down-width="400"
                key-expr="id"
                parent-id-expr="parent_id"
                valueExpr="name"
                placeholder="Подразделение"
                selectionMode="single"
                :display-label="false"
                :defaultValue="filter.departmentId"
                :chooseAll="false"
                :showClearButton="false"
                :showColumnHeaders="false"
                :show-filter-row="true"
                :validate-required="true"
                dropDownHeight="100%"
                @value-changed="changedFilter($event, 'departmentId')"
              ></ai-drop-down-tab>
            </div>
        </template>
        <template #filterPeriodTemplate>
            <div class="d-flex">
                <mped-calculation-period-component
                    :default-value="filter.period && filter.period[0]"
                    :show-clear-button="false"
                    selection-mode="single"
                    @value-changed="changedFilter($event, 'period')"
                />
            </div>
        </template>
        <template #filterViewModeTemplate>
            <div class="d-flex">
                <dx-radio-group
                    class="col-form-label ml-5"
                    v-model="filter.viewMode"
                    :dataSource="viewModeList"
                    value-expr="id"
                    display-expr="name"
                    @value-changed="onViewChanged($event)"
                    layout="horizontal"/>
                <dx-check-box
                    class="ml-5"
                    text="НД по видам"
                    v-model="filter.notMainTypes"
                    :disabled="disabledType"
                    @value-changed="onViewChanged($event)"
                />
            </div>
        </template>
        <template #filterRoundTemplate>
            <div v-if="!props.isPlan" class="d-flex ml-4 mr-4">
                <dx-check-box
                  v-model="filter.prRound"
                  text="С округлением до тыс.руб"
                  @value-changed="reloadData()"
                />
            </div>
        </template>
    </dx-tree-list>
    <footer-grid
      class="pr-1"
      :totalCount="totalCount"
      :showSelectedCounter="false"
    ></footer-grid>
</template>

<script>
export default  {
    name: 'mped-cost-deps-component'
}
</script>

<script setup>
import {
    ref,
    onBeforeMount,
    defineProps,
    computed,
    watch
} from 'vue';
import { useRouter } from "vue-router";
import { DxCheckBox } from 'devextreme-vue';
import DxRadioGroup from 'devextreme-vue/radio-group';
import {
  DxTreeList,
  DxColumn,
  DxScrolling,
  DxLoadPanel,
  DxSorting,
  DxEditing,
  DxSelection,
} from 'devextreme-vue/tree-list';
import FooterGrid from '@/components/grid-card-component/footer-grid.vue';
import AiDropDownTab from '@/components/ai-drop-down-tab/ai-drop-down-tab.vue';

import {
  getEstimateColumns,
  getEstimatePlan,
  setEstimatePlan,
  getEstimateFact,
  setEstimateFact,
  viewModeList, getSprDepartmentsCombo,
} from '@/views/mped/services/mped-estimate-service';
import { setUserData, getUserData } from '@/views/mped/services/mped-service';
import {
    checkHasEditData,
    getAiToolbar,
    getGroupedEditingData,
    saveFullData,
    undoEditData,
} from '@/components/utils/ai-toolbar-generator';
import { expandTree, getAiDataSource, onLoadedData } from '@/components/utils/ai-data-source-generator';
import MpedCalculationPeriodComponent from '@/views/mped/views/calculation/component/mped-calculation-period-component.vue';

const
    columns = ref(),
    totalCount = ref(0),
    treeListRef = ref(),
    isExpand = ref(true),
    filter = ref({
        period: null,
        department: null,
        viewMode: '0',
        notMainTypes: false,
        prRound: false
    });

const router = useRouter();

const disabledType = computed({
    get: () => filter.value.viewMode !== '1'
});

const props = defineProps({
    isPlan: {
        type: Boolean
    }
});

let allIds = [];
let isAfterLoad = false;

const dataSource = getAiDataSource(
    {
        validationFn: () => filter.value.departmentId && filter.value.period && filter.value.viewMode,
        dataFn: props.isPlan ? getEstimatePlan : getEstimateFact,
        paramsFn: () => Object.assign({}, {
            period: filter.value.period[0],
            departmentId: filter.value.departmentId,
            viewMode: filter.value.viewMode,
            plFactId: props.isPlan ? 0 : 1,
            prRound: filter.value.prRound,
            formaId: 0
        }),
        key: 'kod_spr_smet',
        onLoadedFn: (result) => {
            isAfterLoad = true;
            totalCount.value = result.totalCount;
            allIds = result.data.map(x => x.kod_spr_smet);
            onLoadedData({
                data: result.data,
                saveButton: toolbarButtons.save,
                undoEditData,
                dxInstance: getInstance()
            });
        },
        onLoadingFn: async () => {
            if (filter.value.notMainTypes) {
                columns.value = await getEstimateColumns(getFilters());
            }
        }
    }
);

const getInstance = () => {
    return treeListRef.value.instance;
}

let toolbarButtons = {};

const userDataKey = computed({
    get: () => router.currentRoute.value.name
});

watch(filter.value, () => {
    saveUserData();
});

const saveUserData = () => {
    if (userDataKey.value) {
        setUserData(userDataKey.value, filter.value);
    }
};

onBeforeMount(async () => {
  if (userDataKey.value && getUserData(userDataKey.value)) {
    filter.value = getUserData(userDataKey.value);
  }
  columns.value = await getEstimateColumns(getFilters());
});

const onViewChanged = async (e) => {
    if (e.previousValue === '1' && e.newValue !== '1' && filter.value.notMainTypes) {
        filter.value.notMainTypes = false;
    }
    columns.value = await getEstimateColumns(getFilters());
    reloadData();
}

const getFilters = () => {
    return {
        period: filter.value.period?.[0],
        viewMode: filter.value.viewMode,
        notMainTypes: filter.value.notMainTypes,
    };
}

const reloadData = () => {
  dataSource.reload();
}
const reloadDataAndClearSort = () => {
  reloadData();
  treeListRef.value.instance.clearSorting();
  treeListRef.value.instance.cancelEditData();
}

const getDsSprDepartmentsCombo = async () => {
  return await getSprDepartmentsCombo({ formaId: 0, year: filter.value.year, viewMode: filter.value.viewMode });
}

const onCellPrepared = (e) => {
    const colId = e.row?.data?.kod_col;

    if (e.rowType === 'data' && [0, 1, 2, 3, 4, 5, 13].includes(colId)) {
        const rowClassNameMap = {
            0: 'text-primary',
            5: 'text-primary',
            4: 'text-danger',
            13: 'text-success',
        };

        const cellClassMap = {
            1: 'sum_te',
            2: 'sum_all',
            3: 'sum_ee',
        };

        e.cellElement.classList.add(rowClassNameMap[colId]);
        if (e.column.dataField === cellClassMap[colId])
            e.cellElement.classList.add('background-grey');
    }
}

const onEditorPreparing = (e) => {
  if (e.parentType === 'dataRow') {
    if ([0, 4, 5, 13].includes(e.row.data.kod_col)) {
      e.editorOptions.readOnly = true;
    } else if (e.row.data.kod_col === 2 && e.column.dataField === 'sum_all') {
      e.editorOptions.readOnly = true;
    } else if (e.row.data.kod_col === 3 && e.column.dataField === 'sum_ee') {
      e.editorOptions.readOnly = true;
    }
  }
}

const onContentReady = (e) => {
    checkHasEditData(treeListRef.value.instance, toolbarButtons);
    if (isAfterLoad) {
        expandTree({
            ids: allIds,
            dxInstance: getInstance()
        });
    }
    isAfterLoad = false;
}

const onToolbarPreparing = (e) => {
    toolbarButtons = getAiToolbar(e, {
        customs: [
            {
                location: 'before',
                template: 'filterFilialTemplate',
            }, {
                location: 'before',
                template: 'filterPeriodTemplate',
            }, {
                location: 'before',
                template: 'filterViewModeTemplate',
            }, {
                location: 'before',
                template: 'filterRoundTemplate',
            }],
        expand: {
            event: (e) => {
                isExpand.value = !isExpand.value;
            }
        },
        refresh: {
            event: (e) => {
                reloadDataAndClearSort();
            }
        },
        save: {
            event: saveData
        },
        undo: {
            event: (e) => {
                undoEditData(treeListRef.value.instance);
            }
        }
    });
}

const saveData = async () => {
    await saveFullData({
        saveButton: toolbarButtons.save,
        dxInstance: getInstance(),
        saveFn: props.isPlan ? setEstimatePlan : setEstimateFact,
        params: await getSaveParams(),
        reloadDataFn: reloadData
    });
}

const getSaveParams = async () => {
    const editedRows = await getGroupedEditingData(treeListRef.value.instance, { full: true, simple: true });
    editedRows.forEach((row) => {
        if (!row.kod_direct) {
            row.kod_direct = filter.value.departmentId;
        }
        row.tep_el = 0;
    });
    return {
        save: {
            params: {
                period: filter.value.period[0],
                departmentId: filter.value.departmentId,
                viewMode: filter.value.viewMode,
                plFactId: props.isPlan ? 0 : 1,
                formaId: 0
            },
            rows: editedRows
        }
    }
}

const changedFilter = (e, filed) => {
    filter.value[filed] = e;
    reloadData();
}

</script>

<style>
.background-grey {
    background-color: #F5F5F5
}
</style>
